// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"Message_messageContainer__3CK4H","messageContent":"Message_messageContent__d5djq","messageActions":"Message_messageActions__13bdO"};